import { render, staticRenderFns } from "./2020.vue?vue&type=template&id=013665ec&"
import script from "./2020.vue?vue&type=script&lang=js&"
export * from "./2020.vue?vue&type=script&lang=js&"
import style0 from "./2020.vue?vue&type=style&index=0&id=013665ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports